import React from 'react';
import { useEjnSelectedTab } from '../../../hook/useEjnSelectedTab';
import { Tab } from '../../base-components/tab/Tab';

const EjnTabComponent = () => {
  const { selectedTab, setSelectedTab, tabsMapper } = useEjnSelectedTab();

  return (
    <Tab
      selected={selectedTab}
      elements={Object.keys(tabsMapper)}
      onClick={setSelectedTab}
    />
  );
};

const EjnTab = React.memo(EjnTabComponent);

export default EjnTab;
